// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var UspsStates = require("usps-states");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Core__Result = require("@rescript/core/src/Core__Result.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ProfilePageAddressInformationForm_agent_graphql = require("../../__generated__/ProfilePageAddressInformationForm_agent_graphql.bs.js");
var ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql = require("../../__generated__/ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.bs.js");

var validators_zip = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var zip = Form__Helpers.noneIfEmpty(param.zip);
      if (zip !== undefined) {
        return {
                TAG: "Ok",
                _0: zip
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_theState = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var theState = param.theState;
      if (theState !== undefined) {
        return {
                TAG: "Ok",
                _0: theState
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_city = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var city = Form__Helpers.noneIfEmpty(param.city);
      if (city !== undefined) {
        return {
                TAG: "Ok",
                _0: city
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_streetAddress = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var streetAddress = Form__Helpers.noneIfEmpty(param.streetAddress);
      if (streetAddress !== undefined) {
        return {
                TAG: "Ok",
                _0: streetAddress
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators = {
  zip: validators_zip,
  theState: validators_theState,
  city: validators_city,
  streetAddress: validators_streetAddress
};

function initialFieldsStatuses(_input) {
  return {
          zip: "Pristine",
          theState: "Pristine",
          city: "Pristine",
          streetAddress: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            zip: "Pristine",
            theState: "Pristine",
            city: "Pristine",
            streetAddress: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.zip;
  var tmp;
  tmp = typeof match !== "object" ? validators.zip.validate(input) : match._0;
  var match$1 = fieldsStatuses.theState;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.theState.validate(input) : match$1._0;
  var match$2 = fieldsStatuses.city;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.city.validate(input) : match$2._0;
  var match$3 = fieldsStatuses.streetAddress;
  var tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.streetAddress.validate(input) : match$3._0;
  var zipResult = tmp;
  var zipResult$1;
  if (zipResult.TAG === "Ok") {
    var theStateResult = tmp$1;
    if (theStateResult.TAG === "Ok") {
      var cityResult = tmp$2;
      if (cityResult.TAG === "Ok") {
        var streetAddressResult = tmp$3;
        if (streetAddressResult.TAG === "Ok") {
          return {
                  TAG: "Valid",
                  output: {
                    streetAddress: streetAddressResult._0,
                    city: cityResult._0,
                    theState: theStateResult._0,
                    zip: zipResult._0
                  },
                  fieldsStatuses: {
                    zip: {
                      TAG: "Dirty",
                      _0: zipResult,
                      _1: "Shown"
                    },
                    theState: {
                      TAG: "Dirty",
                      _0: theStateResult,
                      _1: "Shown"
                    },
                    city: {
                      TAG: "Dirty",
                      _0: cityResult,
                      _1: "Shown"
                    },
                    streetAddress: {
                      TAG: "Dirty",
                      _0: streetAddressResult,
                      _1: "Shown"
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        zipResult$1 = zipResult;
      } else {
        zipResult$1 = zipResult;
      }
    } else {
      zipResult$1 = zipResult;
    }
  } else {
    zipResult$1 = zipResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            zip: {
              TAG: "Dirty",
              _0: zipResult$1,
              _1: "Shown"
            },
            theState: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            city: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            },
            streetAddress: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurZipField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.zip, validators_zip, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zip: status,
                                  theState: init.theState,
                                  city: init.city,
                                  streetAddress: init.streetAddress
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTheStateField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.theState, validators_theState, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zip: init.zip,
                                  theState: status,
                                  city: init.city,
                                  streetAddress: init.streetAddress
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurCityField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zip: init.zip,
                                  theState: init.theState,
                                  city: status,
                                  streetAddress: init.streetAddress
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurStreetAddressField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.streetAddress, validators_streetAddress, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  zip: init.zip,
                                  theState: init.theState,
                                  city: init.city,
                                  streetAddress: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateZipField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.zip, state.submissionStatus, validators_zip, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zip: status,
                                            theState: init.theState,
                                            city: init.city,
                                            streetAddress: init.streetAddress
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTheStateField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.theState, state.submissionStatus, validators_theState, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zip: init.zip,
                                            theState: status,
                                            city: init.city,
                                            streetAddress: init.streetAddress
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateCityField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zip: init.zip,
                                            theState: init.theState,
                                            city: status,
                                            streetAddress: init.streetAddress
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateStreetAddressField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.streetAddress, state.submissionStatus, validators_streetAddress, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            zip: init.zip,
                                            theState: init.theState,
                                            city: init.city,
                                            streetAddress: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                zip: "Pristine",
                                theState: "Pristine",
                                city: "Pristine",
                                streetAddress: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                zip: "Pristine",
                                theState: "Pristine",
                                city: "Pristine",
                                streetAddress: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateZip: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateZipField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTheState: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTheStateField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateCityField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateStreetAddress: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateStreetAddressField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurZip: (function () {
              dispatch("BlurZipField");
            }),
          blurTheState: (function () {
              dispatch("BlurTheStateField");
            }),
          blurCity: (function () {
              dispatch("BlurCityField");
            }),
          blurStreetAddress: (function () {
              dispatch("BlurStreetAddressField");
            }),
          zipResult: Formality.exposeFieldResult(state.fieldsStatuses.zip),
          theStateResult: Formality.exposeFieldResult(state.fieldsStatuses.theState),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          streetAddressResult: Formality.exposeFieldResult(state.fieldsStatuses.streetAddress),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.zip;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.theState;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.city;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.streetAddress;
              if (typeof tmp$3 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value.abbr;
}

function make(value) {
  return {
          value: value,
          label: value.name
        };
}

var defaultOptions = UspsStates.data.map(make);

var StateOption = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make,
  defaultOptions: defaultOptions
};

var convertVariables = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertVariables;

var convertResponse = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateAgentAddressInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertFragment = ProfilePageAddressInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ProfilePageAddressInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageAddressInformationForm_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageAddressInformationForm(props) {
  var agent = use$1(props.agent);
  var match = use();
  var isUpdatingAgentAddress = match[1];
  var updateAgentAddress = match[0];
  var state = agent.addressInfo.stateAbbr;
  var form = useForm({
        streetAddress: agent.addressInfo.streetAddress,
        city: agent.addressInfo.city,
        theState: state !== undefined ? UspsStates.data.find(function (v) {
                return v.abbr === state;
              }) : undefined,
        zip: agent.addressInfo.zip
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          updateAgentAddress({
                input: {
                  city: param.city,
                  stateAbbr: param.theState.abbr,
                  streetAddress: param.streetAddress,
                  zip: param.zip
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateAgentAddressInfo = param.updateAgentAddressInfo;
                  if (updateAgentAddressInfo !== undefined && updateAgentAddressInfo.__typename === "Agent") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure("An error occurred while submitting your data...");
                  }
                }), undefined, undefined);
        }));
  var match$1 = form.streetAddressResult;
  var tmp;
  tmp = match$1 !== undefined && match$1.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$1._0
      }) : undefined;
  var match$2 = form.cityResult;
  var tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$2._0
      }) : undefined;
  var match$3 = form.theStateResult;
  var tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$3._0
      }) : undefined;
  var match$4 = form.zipResult;
  var tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$4._0
      }) : undefined;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        "Address",
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                                    status: form.status,
                                    submissionErrorToString: (function (v) {
                                        return v;
                                      }),
                                    onSuccessMessage: "Account updated",
                                    resetForm: form.reset,
                                    dismissSubmissionResult: form.dismissSubmissionResult
                                  }),
                              className: "my-4"
                            })
                      ],
                      className: "text-2xl border-b pb-4 font-semibold mb-8"
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Street address:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateStreetAddress((function (v, value) {
                                          return {
                                                  streetAddress: value,
                                                  city: v.city,
                                                  theState: v.theState,
                                                  zip: v.zip
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurStreetAddress();
                                }),
                              disabled: isUpdatingAgentAddress,
                              status: Core__Option.map(form.streetAddressResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.streetAddress, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "City:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateCity((function (v, value) {
                                          return {
                                                  streetAddress: v.streetAddress,
                                                  city: value,
                                                  theState: v.theState,
                                                  zip: v.zip
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurCity();
                                }),
                              disabled: isUpdatingAgentAddress,
                              status: Core__Option.map(form.cityResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.city, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$1
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "State:",
                      children: [
                        JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                              getOptionLabel: getOptionLabel,
                              getOptionValue: getOptionValue,
                              isClearable: true,
                              onBlur: (function (param) {
                                  form.blurTheState();
                                }),
                              onChange: (function (state) {
                                  form.updateTheState((function (v, value) {
                                          return {
                                                  streetAddress: v.streetAddress,
                                                  city: v.city,
                                                  theState: value,
                                                  zip: v.zip
                                                };
                                        }), Core__Option.map(state, (function (v) {
                                              return v.value;
                                            })));
                                }),
                              options: defaultOptions,
                              value: Core__Option.map(form.input.theState, (function (v) {
                                      return {
                                              value: v,
                                              label: v.name
                                            };
                                    })),
                              status: Core__Option.getOr(Core__Option.map(form.theStateResult, (function (r) {
                                          return Core__Result.isError(r);
                                        })), false) ? "Failure" : "Neutral"
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$2
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Zip:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateZip((function (v, value) {
                                          return {
                                                  streetAddress: v.streetAddress,
                                                  city: v.city,
                                                  theState: v.theState,
                                                  zip: value
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurZip();
                                }),
                              disabled: isUpdatingAgentAddress,
                              status: Core__Option.map(form.zipResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.zip, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$3
                            })
                      ]
                    }),
                JsxRuntime.jsx(FormV5.FormGroup.make, {
                      children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                            onClick: (function (extra) {
                                return Form__Helpers.preventDefault(form.submit, extra);
                              }),
                            disabled: !form.valid() || isUpdatingAgentAddress,
                            children: "Save"
                          })
                    })
              ],
              className: "flex flex-col my-8"
            });
}

var make$1 = ProfilePageAddressInformationForm;

exports.FormConfig = FormConfig;
exports.StateOption = StateOption;
exports.UpdateAgentAddressInfoMutation = UpdateAgentAddressInfoMutation;
exports.AgentFragment = AgentFragment;
exports.make = make$1;
/* defaultOptions Not a pure module */
